import styled from 'styled-components';

// Navigation Tabs Styles
export const NavTabs = styled.nav`
  display: flex;
  justify-content: center;
  gap: 2rem;
  margin-top: 10rem;
  background: rgba(255, 255, 255, 0.4);
  backdrop-filter: blur(10px);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  flex-wrap: wrap; /* Allow wrapping on smaller screens */

   @media (max-width: 1050px) {
    margin-top: 6rem;

  }
  @media (max-width: 768px) {
   display: flex;
    margin-top: 6rem;
   align-items: center;
    overflow-x: auto; /* Add horizontal scrolling if needed */
    justify-content: center;
    gap: 1rem;
 
    font-size: 0.5rem; /* Scale down the tab size */
  }
 
`;

export const NavTab = styled.a<{ $active: boolean }>`
  text-decoration: none;
  font-weight: bold;
  padding: 0.75rem 1.5rem;
  border-bottom: 3px solid transparent;
  color: ${(props) => (props.$active ? props.theme.primary : props.theme.text)};
  transition: color 0.3s ease, border-bottom 0.3s ease;
  text-align: center;
  white-space: nowrap; /* Prevent text wrapping */

  ${(props) =>
    props.$active &&
    `
    border-bottom: 3px solid ${props.theme.primary};
  `}

  &:hover {
    color: ${(props) => props.theme.primary};
  }

  @media (max-width: 768px) {
    padding: 0.5rem 1rem;
    font-size: 0.9rem;
  }
`;

// Section Wrapper Styles
export const SectionWrapper = styled.section<{ background?: string }>`
  padding: 4rem 2rem;
  background: ${(props) => props.background || 'rgba(255, 255, 255, 0.8)'};
  backdrop-filter: ${(props) =>
    props.background === '#fff' ? 'none' : 'blur(10px)'};
  display: flex;
  max-width: 80vw;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 0 auto;

  @media (max-width: 768px) {
    max-width: 100%; /* Full width for smaller screens */
    padding: 2rem 1rem;

  }
`;

export const ContentContainer = styled.div`
  max-width: 1200px;
  width: 100%;
  background: #fff;
  border-radius: 10px;
  padding: 3rem;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  text-align: left;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2);
  }

  @media (max-width: 768px) {
    padding: 2rem;
         margin-top: 6rem;
  }

  h3 {
    text-align: center;
    padding: 1rem 0;
  }

  h2 {
    font-size: 2.5rem;
  }

  ul {
    margin-left: 2rem;
    padding-bottom: 2rem;
  }
`;

export const SectionTitle = styled.h2`
  font-size: 1.5rem;
  color: ${(props) => props.theme.primary};
  margin-bottom: 2.5rem;
  text-align: center;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

export const SectionSubtitle = styled.p`
  font-size: 1.0rem;
  color: ${(props) => props.theme.text};
  text-align: center;
  margin-bottom: 1rem;
  padding-top: 1rem;
  max-width: 800px;
  margin: 0 auto;

  @media (max-width: 768px) {
    font-size: 1rem;
    margin-bottom: 1.5rem;
  }
`;

export const FeaturesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  width: 100%;
`;

export const FeatureCard = styled.div`
  background: #f0f4f8;
  border-radius: 10px;
  padding: 2rem;
  text-align: center;
  transition: transform 0.3s ease, background 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    background: #e6edf5;
  }

  svg {
    font-size: 2rem;
    color: ${(props) => props.theme.primary};
    margin-bottom: 1rem;
  }

  h3 {
    font-size: 1.5rem;
    color: ${(props) => props.theme.secondary};
    margin-bottom: 1rem;
    text-align: center;
  }

  p {
    font-size: 1rem;
    color: ${(props) => props.theme.text};
    line-height: 1.6;
  }
`;

export const BenefitsList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 2rem 0;
  display: flex;
  flex-direction: column;
  align-items: start;

  li {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 1rem;
    font-size: 1.1rem;
    color: ${(props) => props.theme.text};

    svg {
      margin-right: 0.5rem;
      color: ${(props) => props.theme.primary};
    }
  }
`;
